import { Colors } from '../../consts/Colors';

export default class Zone3 extends Phaser.GameObjects.Container {
    constructor(scene, itemData) {
        super(scene, itemData.zoneX, itemData.zoneY, []);

        scene.add.existing(this);
        this.scene = scene;
        this.isDone = false;
        this.index = itemData.trueId;
        this.doneImg = itemData.image;
        this.zoneId = itemData.zoneId;
        this.trueId = itemData.trueId;
        this.itemData = itemData;
        this.isError = false;
        this.item = this.scene.add.image(0, 0, 'imgPlaceholder').setOrigin(0.5);

        this.dropZone = this.scene.add.rectangle(0, 0, this.item.width + 80, this.item.height + 80, Colors.Elmt.Blue, 0).setOrigin(0.5);
        this.dropZone.setStrokeStyle(1, Colors.Elmt.Black, 0);
        this.add(this.item);
        this.add(this.dropZone);
        this.setActive()
    }

    setActive() {
        this.isError = false;
        this.item.setTint(0xFFFFFF);
        this.item.setScale(1);
        this.setSize(this.dropZone.width, this.dropZone.height);
        this.setInteractive({ dropZone: true });
        // this.on('pointerover', this.onPointerOver);
        // this.on('pointerout', this.onPointerOut);
    }

    setDone(cardImg) {
        this.disableInteractive();
        this.isDone = true;
        this.item.setTint(0xFFFFFF);
        this.item.setScale(1);
        this.item.setTexture(cardImg);
        this.itemStroke = this.scene.add.graphics();
        this.itemStroke.lineStyle(8, Colors.Elmt.Green, 1); // Définit l'épaisseur et la couleur de la bordure
        this.itemStroke.strokeRect(
            -this.item.displayWidth / 2,
            -this.item.displayHeight / 2,
            this.item.displayWidth,
            this.item.displayHeight
        );
        this.add(this.itemStroke);
        // this.itemStroke.setScale(0.9)
        this.itemStroke.setAlpha(1);
        this.scene.tweens.add({
            targets: [this.itemStroke, this.item],
            alpha: 0,
            delay: 1500,
            duration: 100,
            onComplete: () => {
                this.scene.replaceItem(this.x, this.y, this.itemData)
                this.destroy()
            }
        });
        // this.transitionOut()
      
    }

    setWrong(cardImg) {
        this.isError = true;
        console.log("Zone setWrong zone")
        this.item.setTint(0xFFFFFF);
        this.item.setScale(1);
        this.item.setTexture(cardImg);
        this.itemStroke = this.scene.add.graphics();
        this.itemStroke.lineStyle(8, Colors.Elmt.Orange, 1); // Définit l'épaisseur et la couleur de la bordure
        this.itemStroke.strokeRect(
            -this.item.displayWidth / 2,
            -this.item.displayHeight / 2,
            this.item.displayWidth,
            this.item.displayHeight
        );
        this.add(this.itemStroke);
        // this.itemStroke.setScale(0.9)
        this.itemStroke.setAlpha(0);
        this.scene.tweens.add({
            targets: this.itemStroke,
            alpha: 1,
            duration: 400,
            // ease: 'Linear',
            repeat: 4,
            yoyo: true,
            onComplete: () => {
                // this.item.setScale(0.5);
            }
        });
        this.disableInteractive();
    }

    onPointerOver() {
        this.item.setTint(0x555555);
        if (this.isDone) {
            this.item.setScale(1);
        } else {
        }

    }
    onPointerOut() {
        this.item.setTint(0xffffff);
        if (this.isDone) {
            this.item.setScale(0.5);
        } else {
        }
    }
    dragOnPointerOver() {
        this.item.setTint(0x777777);
        this.item.setScale(1);
    }
    dragOnPointerOut() {
        this.item.setTint(0xFFFFFF);
        this.item.setScale(0.5);
    }

}